const PromotionIcon = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none"><path fill="#fff" d="m.041 1.482 2.736 9.646c.27 1.013 1.631 1.19 2.153.284l2.247-4.236 4.234-2.247c.91-.521.729-1.882-.285-2.153L1.48.041A1.175 1.175 0 0 0 .041 1.482Z"/><path fill="#546EDB" d="M11.987 8.99h-.963v-.966a1.019 1.019 0 0 0-2.037 0v.963h-.963a1.016 1.016 0 1 0 0 2.033h.963v.963a1.016 1.016 0 1 0 2.033 0v-.963h.963c.562 0 1.017-.454 1.017-1.016a1.008 1.008 0 0 0-1.013-1.014Z"/></svg>
    )
}

export default PromotionIcon;